import type { Product } from 'product/types/Product'
import { useMemo } from 'react'

export function useMessageDisclaimer({ product }: { product?: Product }) {
	const disclaimerType = useMemo(() => {
		if (!product?.colors) {
			return null
		}
		return (
			product.colors.find((color) => !!color.disclaimer)?.disclaimer ?? null
		)
	}, [product])

	return {
		disclaimerType,
	}
}
